import { createContext, useContext, useState, useEffect } from 'react';

// Tema del panel: 'dark' (por defecto, el actual) | 'color' (claro verde/blanco).
// El valor se monta como atributo data-theme en <html> y App.css lo aplica vía
// :root[data-theme="color"]. Se persiste por usuario en localStorage('nv-theme').
const ThemeContext = createContext(null);

function readTheme() {
  try {
    return localStorage.getItem('nv-theme') === 'color' ? 'color' : 'dark';
  } catch {
    return 'dark';
  }
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('nv-theme', theme); } catch {}
  }, [theme]);

  const setTheme = (t) => setThemeState(t === 'color' ? 'color' : 'dark');
  const toggle = () => setThemeState((t) => (t === 'color' ? 'dark' : 'color'));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext) || { theme: 'dark', setTheme: () => {}, toggle: () => {} };
}
